
import edu_request from '@/utils/edu_request'
import qs from 'qs'

// 新试卷
export function getNewExamApi(params) {
  return edu_request({
    url: 'subject/index/startExercise',
    method: 'get',
    params
  })
}
// 对答案-新
export function newCheck(params) {
  return edu_request({
    url: 'subject/index/checkAnswer',
    method: 'get',
    params
  })
}

// 查看解析-错题的
export function newWrongAnalyse(params) {
  return edu_request({
    url: 'subject/index/getErrExerciseAnalyse',
    method: 'get',
    params
  })
}

// 交卷-新
export function newSubmit(params) {
  return edu_request({
    url: 'subject/index/submitAnswer',
    method: 'post',
    data: qs.stringify(params)
  })
}

// 评测结果-新
export function newGetresult(params) {
  return edu_request({
    url: 'subject/index/getExerciseResult',
    method: 'get',
    params
  })
}

// 查看解析-新
export function newAnalyse(params) {
  return edu_request({
    url: 'subject/index/getExerciseAnalyse',
    method: 'get',
    params
  })
}

// 查看是否需要继续做题
export function getRetainExercise(params) {
  return edu_request({
    url: 'subject/index/getRetainExercise',
    method: 'get',
    params
  })
}
// 智能刷题首页
export function getZnstIndexApi(params) {
  return edu_request({
    url: 'subject/index/statisticsLessonSmartExerciseInfo',
    methods: 'get',
    params
  })
}
// 智能刷题数据
export function getSmartQuestions(params) {
  return edu_request({
    url: '/exam/zkbwx/getIntelligentPraxis',
    method: 'get',
    params: params
  })
}
// 智能刷题学习报告
export function getZnstReportApi(params) {
  return edu_request({
    url: 'subject/index/getLessonUserExerciseSituation',
    methods: 'get',
    params
  })
}
// 随堂练习报告页
export function getSTEvaluationInfo(params) {
  return edu_request({
    url: '/lesson/lesson/getSTEvaluationInfo',
    method: 'get',
    params: params
  })
}
// 排行榜
export function getPaperIdExerciseTop10(params) {
  return edu_request({
    url: 'subject/index/getPaperIdExerciseTop10',
    method: 'get',
    params: params
  })
}
